import { useCallback, useEffect, useState } from 'react';
import { markNotificationRead, readNotificationCenter, upsertNotification } from './notificationCenter.js';
import { notificationCenterKey } from './persistedState.js';
export function useNotificationCenter(app, user, enabled) {
    const key = notificationCenterKey(app, user);
    const [state, setState] = useState(() => ({ key, entries: enabled ? readNotificationCenter(key) : [] }));
    useEffect(() => { setState({ key, entries: enabled ? readNotificationCenter(key) : [] }); }, [key, enabled]);
    useEffect(() => {
        if (!enabled || state.key !== key)
            return;
        try {
            localStorage.setItem(key, JSON.stringify(state.entries));
        }
        catch { /* private mode or quota: keep this session usable */ }
    }, [state, key, enabled]);
    const update = useCallback((change) => {
        if (!enabled)
            return;
        setState(current => {
            if (current.key !== key)
                return current; // retired identity callbacks must never populate the next account
            const entries = change(current.entries);
            return entries === current.entries ? current : { key, entries };
        });
    }, [key, enabled]);
    return {
        entries: state.key === key ? state.entries : [],
        record: useCallback((entry) => update(entries => upsertNotification(entries, entry)), [update]),
        markRead: useCallback((id, read) => update(entries => markNotificationRead(entries, id, read)), [update]),
        markAllRead: useCallback(() => update(entries => markNotificationRead(entries, null)), [update]),
        clear: useCallback(() => { try {
            localStorage.removeItem(key);
        }
        catch { /* unavailable */ } update(() => []); }, [key, update]),
    };
}
//# sourceMappingURL=useNotificationCenter.js.map